import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .content {
    width: 100%;
    align-items: flex-start;
    /* border-top: 1px solid var(--tab-bar-border); */
    padding: 30px 0 0 0;
    overflow: visible;
  }
  .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }

  .content.column .subtitle {
    margin: 0 0 14px 0;
    display: flex;
    align-items: center;
  }
  .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content label {
    padding: 0 0 10px 0;
    line-height: 130%;
    display: flex;
    align-items: center;
  }
  .grid-content label.title {
    text-align: right;
    text-transform: uppercase;
    font-size: 0.8rem;
    justify-content: flex-end;
    /* max-width: 160px; */
  }
  .grid-content label.value {
    margin: 0 0 0 15px;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.stats label.title:nth-child(9),
  .grid-content.stats label.value:nth-child(10) {
    padding-bottom: 0 !important;
  }
  .social_list {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
  }
  .social_list a {
    /* border: 1px solid hsl(197, 6%, 33%); */
    border-radius: 10px;
    padding: 10px 14px 11px 40px;
    line-height: 100%;
    font-size: 0.8rem;
    display: block;
  }
  .user_panels #user-overview_panel {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow-y: auto;
    max-height: 350px;
    min-height: 350px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/wallet.css */
  .wallet_tabs_panel {
    display: none;
    width: 100%;
  }
`

const developerCSS = css``

export const UserOverviewCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
